import { createContext, useContext, useState } from 'react';

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [dadosDashboardProvider, setDadosDashboardProvider] = useState(null);

  return (
    <DashboardContext.Provider value={{ dadosDashboardProvider, setDadosDashboardProvider }}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);
